/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />
///<reference path="../../components/common/ratings.service.ts"/>

module Meevo.Plugins.ProfileSettings {
    "use strict";

    export class ProfileSettingsContext extends Components.BaseClasses.DataMaintenanceContextBase {

        protected imageGalleryService: any;
        constructor(appSettings: Components.Common.IAppSettings,
            dataService: Components.BaseClasses.IDataService,
            modalService: Components.Modal.IModalService,
            identityService: Components.Common.IIdentityService,
            loggingService: Components.Logging.ILoggingService,
            securityChecker: Components.Common.ISecurityService,
            trackingService: Components.Tracking.ITrackingService,
            rootScope: ng.IRootScopeService,
            busyService: Components.Busy.IBusyService,
            customDataContextConfig: Model.ICustomDataContextConfig,
            imageGalleryService: Meevo.Components.Common.IImageGalleryService,
            ratingsService: Meevo.Components.Common.IRatingsService) {

            super(appSettings,
                dataService,
                modalService,
                identityService,
                loggingService,
                securityChecker,
                trackingService,
                customDataContextConfig, false);

            this.imageGalleryService = imageGalleryService;
            this.initializeSections();
        }

        initializeContext(): void {
            // initialize end points
            this.baseEndpoint = this.appSettings.API_ENDPOINTS.profileSettings;
            // initialize templatepaths
            this.sectionTemplatePath = "app/plugins/profileSettings/sectionViews/";

            // TODO: Review per conversation if we should use the "main" tab key or overall module key as the base of the CRUD action keys
            //this.buildCrudSecurityKeysBase(this.securityKeys.MANAGEMENT_PROFILESETTINGS_TAB_MAIN, true, true, false, false, false);
        }

        initializeSections(): void {
            this.initializeContext();
            // Adding sections items that represent areas in the maintenance form
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_PROFILESETTINGS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new MainSection(0,
                    "SECTION_EMPLOYEE_MAIN",
                    "main.html",
                    true,
                    false,
                    this.baseEndpoint,
                    "",
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.ProfileSettingMain,
                    this.appSettings,
                    this.securityKeys.MANAGEMENT_PROFILESETTINGS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_PROFILESETTINGS_TAB_SERVICES + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new ServicesSection(1,
                    "SECTION_EMPLOYEE_SERVICES",
                    "services.html",
                    false,
                    false,
                    this.appSettings.API_ENDPOINTS.employee,
                    "",
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.ProfileSettingServices,
                    null,
                    this.securityKeys.MANAGEMENT_PROFILESETTINGS_TAB_SERVICES + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_PROFILESETTINGS_TAB_IMAGEGALLERY + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new ImageGallerySection(2,
                    'SECTION_IMAGE_GALLERY',
                    'imageGallery.html',
                    false,
                    true,
                    '',
                    'imagegallery',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.EmployeeImageGallery,
                    this.modalService,
                    this.imageGalleryService,
                    this.securityKeys.MANAGEMENT_PROFILESETTINGS_TAB_IMAGEGALLERY + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

        }

        selectSection(item): void {
            switch (item.sectionId) {
                case 1:
                    this.buildCrudSecurityKeysBase(this.securityKeys.MANAGEMENT_PROFILESETTINGS_TAB_SERVICES);
                    break;
                case 2:
                    this.buildCrudSecurityKeysBase(this.securityKeys.MANAGEMENT_PROFILESETTINGS_TAB_IMAGEGALLERY);
                    break;
                default:
                    this.buildCrudSecurityKeysBase(this.securityKeys.MANAGEMENT_PROFILESETTINGS_TAB_MAIN);
                    break;
            }
            super.selectSection(item);
        }

        initializeHeader(model: any): void {
            if (!this.isAdding)
                this.headerContent = model.isLocationEmployee ? model.lastName + ', ' + model.firstName : model.userName;

            this.visualizeTabs(model.isLocationEmployee);
        }

        protected buildCrudSecurityKeysBase(baseKey, hasCreateKey = false, hasCopyKey = false) {
            this.editSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;
            this.deleteSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_DELETE;
            this.addSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_CREATE;
            this.copySecurityKey = baseKey + ((hasCopyKey) ? Meevo.Components.Common.SecurityParts.KEY_PART_COPY : Meevo.Components.Common.SecurityParts.KEY_PART_WRITE);
        }

        postCancel(): void {
        }

        get showDelete(): boolean {
            return false;
        }

        get showCopy(): boolean {
            return false;
        }

        visualizeTabs(isLocationEmployee: boolean): void {
            this.sections.forEach(s => {
                if (s.displayNameContentKey === "SECTION_EMPLOYEE_SERVICES")
                    s.isVisible = true;
                if (s.displayNameContentKey === "SECTION_IMAGE_GALLERY")
                    s.isVisible = isLocationEmployee;
            });
        }

        get isDisabled(): boolean {
            return this.isReadonly;
        }

        openChangePassword(user: Model.User) {

            if (Model.Guard.isNothing(user))
                return;

            const options: Components.Modal.IModalOptions = {
                templateUrl: 'app/components/changePassword/changePassword.html',
                clickOutsideToClose: false,
                locals: {
                    model: user,
                    userId: user.id,
                    userName: user.userName,
                    requireChangePassword: false
                },
                controller: 'meevo.changePassword.ChangePasswordController',
                controllerAs: 'changePassword',
                bindToController: true
            };
            this.modalService.showCustom(options)
                .then((result) => {
                    console.log(result);
                });
        }
    }
}